import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import { IsBillableSelection } from "../../customer/orderTemplate/IsBillableSelection";
import { useState } from "react";

type Props = {
  isBillable: boolean;
  onIsBillableChange: (isBillable: boolean) => void;
  tooltipText: string;
  disabled?: boolean;
};

export const OrderFormShortOtherSettings = ({
  isBillable,
  onIsBillableChange,
  tooltipText,
  disabled = false,
}: Props) => {
  const { t } = useTranslation("customers");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FormSection
      title={t("customers:orderTemplate:otherSettings")}
      collapse
      open={isOpen}
      toggleOpen={() => setIsOpen(!isOpen)}
    >
      <Grid item xs={3} />
      <Grid item xs={9}>
        <IsBillableSelection
          isBillable={isBillable}
          onIsBillableChange={onIsBillableChange}
          tooltipText={tooltipText}
          disabled={disabled}
        />
      </Grid>
    </FormSection>
  );
};
